import { useEffect } from 'react';
import Static from '../canvases/static';

interface IProps {
  manager: Static;
  isManagerInit: boolean;
  /**
   * Панель управления скрыта — тогда канва занимает всю ширину экрана.
   * Значение читает вызывающий модуль: у оверлея и трансляции это разные
   * слайсы, а киту про чужой store знать нельзя.
   */
  isHideControlPanel?: boolean;
}

const controlPanelWidth = 300;

function useResizeCanvas(props: IProps) {
  const { manager, isManagerInit, isHideControlPanel } = props;

  useEffect(() => {
    if (!manager) return;
    if (!isManagerInit) return;

    function canvasResize() {
      if (!manager) return;
      const sizeOffset = isHideControlPanel ? { width: 0, height: 0 } : { width: controlPanelWidth, height: 0 };
      manager.resizeByScreen({ sizeOffset });
    }

    canvasResize();
    window.addEventListener('resize', canvasResize);

    return () => {
      window.removeEventListener('resize', canvasResize);
    };
  }, [isHideControlPanel, isManagerInit, manager]);
}

export default useResizeCanvas;
